<template>
  <div>
    <hr color="B3C3EC">
    <div class="content">
    　　邮箱验证结果：<br/>{{verityResult}}<br/>
        等待{{count}}秒后返回登陆页面。
    <hr color="B3C3EC">
    </div>
    <el-footer class="footer">
      <el-row>
        <el-col :span="24">
          <div class="copyright">
            ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="advice">
            抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>
<script>
  import {getRequest} from '../../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
    data(){
      return {
        verityResult: "",
        count:"",//倒计时
      }
    },
    mounted: function () {
      this.verifyUserEmail();
    },
    methods: {
      verifyUserEmail: function() {
        let emailVerifyCode = this.$route.query.emailVerifyCode;
        getRequest('/auth/mail/verifyUserEmail', {
          emailVerifyCode: emailVerifyCode||''
        }).then(resp=> {
          if (resp.status == 200) {
            //HTTP层成功，业务状态在resp.data.status
            var data = resp.data;
            if (data && data.status == 200) {
              //业务成功，message即验证结果文案
              this.verityResult = data.message || '邮箱验证成功，请重新登陆。';
            } else {
              //业务失败，展示失败原因
              this.verityResult = (data && data.message) || '邮箱验证失败。';
            }
            this.clickJump();
          } else {
            //HTTP层失败
            this.verityResult = '网络异常，请稍后再试。';
          }
        }, resp=> {
          Message.error('用户非法⊙﹏⊙∥!');
          this.$router.replace({path: '/'});
        });
      },
      //几秒后进入跳转页面 
      clickJump(){ 
        const timejump = 3; 
        if(!this.timer){ 
          this.count = timejump; 
          this.show = false; 
          this.timer = setInterval(()=>{ 
            if (this.count > 0 && this.count <= timejump ) { 
              this.count--; 
            } else { 
              this.show = true; 
              clearInterval(this.timer); 
              this.timer = null; 
              //跳转的页面写在此处 
              this.$router.replace({path: '/'}); 
            } 
          },1000) 
        } 
      },
    }
  }
  
</script>
<style scoped>
  .content a {
    cursor: pointer;
    color: blue;
    text-decoration:none;
  }
  .content a:hover {text-decoration:underline;color:#FF0000}
  .content {
    line-height: 2em;
    text-align: center;
  }
  
.footer a {
    cursor: pointer;
    color: #333;
    text-decoration:none;
}
.footer a:hover {text-decoration:underline;color:#FF0000}
.footer .copyright {
  margin: 5px auto;
  text-align: center;
  font-size: 14px;
  color: #333;
}
.footer .advice {
  margin: 0;
  text-align: center;
  font-size: 12px;
  color: #444;
}
</style>
